// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__OLljX","sendOtp":"AuthorizeToLogin_sendOtp__17AHj"};